// Bot-practice CTA (full-width take-two primary button).
//
// Per UI-SPEC accent-reserved #3: distinct full-width CTA below the
// active-match list. NOT active-match-cap-gated (DEC-009 excludes
// bot-practice — bot matches do not count toward the cap, so this CTA is
// ALWAYS enabled).

import type { JSX } from 'react'
import { FormattedMessage } from 'react-intl'
import { Btn } from '../components/Btn'

export interface BotPracticeCtaProps {
  readonly onClick: () => void
  /**
   * FLOW-06 — when true, render a one-shot teaching caption beneath the CTA
   * steering a just-finished-tutorial player toward a safe bot match.
   */
  readonly steer?: boolean
  /**
   * ARCA-130 — drop the guest "— no signup" suffix when the CTA renders in an
   * authenticated context (the lobby). The splash keeps the default guest copy
   * since zero-sign-in bot play is its whole pitch.
   */
  readonly authed?: boolean
}

export function BotPracticeCta({
  onClick,
  steer = false,
  authed = false,
}: BotPracticeCtaProps): JSX.Element {
  return (
    <>
      <Btn
        kind="primary"
        size="lg"
        block
        testId="bot-practice-cta"
        dataCta="bot-practice"
        onClick={onClick}
      >
        {authed ? (
          <FormattedMessage
            id="social.lobby.bot_practice_cta_authed"
            defaultMessage="Practice vs Bot"
          />
        ) : (
          <FormattedMessage
            id="social.lobby.bot_practice_cta"
            defaultMessage="Practice vs Bot — no signup"
          />
        )}
      </Btn>
      {steer ? (
        <p
          data-screen-region="bot-practice-steer"
          style={{
            margin: 'var(--space-2) 0 0',
            textAlign: 'center',
            fontFamily: 'Manrope, system-ui, sans-serif',
            fontWeight: 600,
            fontSize: 'var(--font-size-13)',
            lineHeight: 1.4,
            color: 'var(--color-text-secondary)',
          }}
        >
          <FormattedMessage id="social.lobby.bot_practice_steer" />
        </p>
      ) : null}
    </>
  )
}
